import { useQuickStrategyContext } from "@/contexts/QuickStrategyContext";
import { Plus } from "lucide-react";
import { useCallback } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

const NoScannerFound = () => {
  const { changeScannerType, openQuickStrategy, setQuickStrategyModalToggle } =
    useQuickStrategyContext();

  const handleQuickStrategyCreate = useCallback(() => {
    changeScannerType(true);
    setQuickStrategyModalToggle(true);
  }, []);

  return (
    <div className="flex flex-col items-center w-full py-8 ">
      <Plus
        size={64}
        strokeWidth={1}
        onClick={handleQuickStrategyCreate}
        className="cursor-pointer"
      />
      <div className="flex items-center  flex-col">
        <p className="opacity-30">
          You don’t have any personal scanners. Click to create a scanner now
        </p>
        <Popover>
          <PopoverTrigger><p className="text-blue-600">Learn more</p></PopoverTrigger>
          <PopoverContent>
            <div>
              <div className="flex">
                <div><h2 className="font-bold text-lg">Introducing Scanners</h2></div>

              </div>
              <div className="mt-3">
                <img src="/images/scanners/scanners_muted.png" className=""></img>
              </div>
              <div className="text-muted-foreground text-xs mt-3">
                Scanners are a great way to get alerts when your strategy generates a signal, or when a signal is generated for a group of your preferred trading symbols.  Scanners allow you to stay ahead of the curve and monitor market movements across a group of assets, rather than focusing on a single instrument.
              </div>
            </div>

          </PopoverContent>
        </Popover>


      </div>
    </div>
  );
};

export default NoScannerFound;
